import {Base} from "@/api/Base"

export class GiDelete extends Base {
    path = "gi/delete"
}